module.exports = __webpack_public_path__ + "static/media/ProximaNovaBold.62d4d7d3.otf";